import request from '@/utils/request'
/* 获取用户列表接口 */
export function getUsersPage(data) {
  return request({
    url: '/admin/users/page',
    method: 'get',
	  params:data
  })
}

/* 获取用户统计接口 */
export function getUsersCount(data) {
  return request({
    url: '/admin/users/count',
    method: 'get',
      params:data
  })
}
